import React from 'react';
import CustomSelect from '../../ui/primitives/CustomSelect';

const LinkedProjectSelector = ({
  linkedProjects,
  selectedProjectId,
  onProjectChange,
}) => {
  const truncate = (text, maxLength = 25) => {
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + '...';
  };

  const options = linkedProjects?.map((project) => ({
    id: project.linked_project_id,
    name: `${project.linked_project_key} - ${truncate(project.linked_project_name)}`,
    title: `${project.linked_project_key} - ${project.linked_project_name}`,
    _raw: project,
  })) ?? [];

  const handleChange = (selectedId) => {
    const selected = linkedProjects.find(
      (p) => p.linked_project_id === selectedId
    );
    onProjectChange(selected);
  };

  return (
    <CustomSelect
      value={selectedProjectId}
      onChange={handleChange}
      options={options}
      placeholder="Select a JIRA project"
      required
      renderOption={(opt) => (
        <span title={opt.title}>
          {opt.name}
        </span>
      )}
    />
  );
};

export default LinkedProjectSelector;